module.exports = __webpack_public_path__ + "media/images/cedel2-a89f6165d51541dae2631c7d08f7f602.png";